import React from 'react';
import { trackClick } from '../utils/analytics';
import {
  MinimalGlobalStyle,
  Container,
  Inner,
  BackButton,
  Header,
  PageTitle,
  Bio,
  HeaderLinks,
  HeaderLink,
  Section,
  SectionTitle,
  Card,
  CardTop,
  CardTitle,
  CardDescription,
  CardLinks,
  CardLink,
  Tag,
  TagRow,
} from '../components/minimal';

const DISCORD_ACCENT = '#7289da';

interface Bot {
  name: string;
  description: string;
  inviteLink: string;
  websiteLink: string;
  tags: string[];
}

const bots: Bot[] = [
  {
    name: 'HypeX',
    description:
      'Turns your Discord server into a social stock market. Buy and sell shares of server members, track prices based on activity and mentions, compete on leaderboards, and earn dividends.',
    inviteLink:
      'https://discord.com/oauth2/authorize?client_id=1425294342825967709&permissions=274878221376&scope=bot%20applications.commands',
    websiteLink: 'https://hype-x.vercel.app/',
    tags: ['social', 'games', 'economy'],
  },
  {
    name: 'ServerSage',
    description:
      'AI-powered community assistant featuring intelligent moderation, smart ticketing, analytics, and member management. Welcome messages, automated moderation, support tickets, and engagement tracking.',
    inviteLink:
      'https://discord.com/oauth2/authorize?client_id=1424540840939880551&permissions=8&scope=bot%20applications.commands',
    websiteLink: 'https://server-sages.vercel.app/',
    tags: ['moderation', 'AI', 'community'],
  },
];

const DiscordPage: React.FC = () => {
  const handleJoin = () => {
    trackClick('discord_join', { server: 'main' });
  };

  return (
    <>
      <MinimalGlobalStyle $accent={DISCORD_ACCENT} />
      <Container>
        <BackButton />
        <Inner>
          <Header>
            <PageTitle>Discord</PageTitle>
            <Bio>
              Community server plus Discord bots I&apos;ve built for running servers.
            </Bio>
            <HeaderLinks>
              <HeaderLink
                href="https://discord.gg/GJJrgsh4Tx"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleJoin}
              >
                Join the server
              </HeaderLink>
            </HeaderLinks>
          </Header>

          <Section>
            <SectionTitle>A5omic Server</SectionTitle>
            <Card>
              <CardTop>
                <CardTitle>Join the community</CardTitle>
              </CardTop>
              <CardDescription>
                Updates on new releases, event announcements, music and tech talk, and the
                usual late-night chaos. Music channels, tech talk, gaming, and community
                announcements.
              </CardDescription>
              <CardLinks>
                <CardLink
                  href="https://discord.gg/GJJrgsh4Tx"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleJoin}
                >
                  discord.gg/GJJrgsh4Tx &rarr;
                </CardLink>
              </CardLinks>
            </Card>
          </Section>

          <Section>
            <SectionTitle>Discord Bots I&apos;ve Built</SectionTitle>
            {bots.map(bot => (
              <Card key={bot.name}>
                <CardTop>
                  <CardTitle>{bot.name}</CardTitle>
                </CardTop>
                <CardDescription>{bot.description}</CardDescription>
                <TagRow>
                  {bot.tags.map(t => <Tag key={t}>{t}</Tag>)}
                </TagRow>
                <CardLinks>
                  <CardLink
                    href={bot.inviteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackClick('bot_invite', { bot_name: bot.name })}
                  >
                    Add to server &rarr;
                  </CardLink>
                  <CardLink
                    href={bot.websiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackClick('bot_website', { bot_name: bot.name })}
                  >
                    Website &rarr;
                  </CardLink>
                </CardLinks>
              </Card>
            ))}
          </Section>
        </Inner>
      </Container>
    </>
  );
};

export default DiscordPage;
